import { Component } from "@angular/core";
import { UploadService } from "../../infrastructure/upload/upload-service";
import { GraphicsRepository } from "../../domain/graphics-repository";
import { Logger } from "../../infrastructure/logger";
import { UserService } from "../../domain/user-service";
import { Font } from "../../domain/font";
import { UI } from "../../services/ui.service";

@Component({
  selector: "icn-upload-graphics",
  templateUrl: "./upload-graphics.html",
  styleUrls: ["./upload-graphics.scss"],
})
export class UploadGraphicsComponent {
  file: File = null;
  graphicsFileChosenName: string = "";
  thumbnailFileChosenName: string = "";
  sampleVideoFileChosenName: string = "";
  fontFileChosenName: string = "";
  fontName: string = "";
  graphicsName: string = "";
  graphicsDescription: string;
  isUploadingGraphics: boolean = false;
  isUploadingThumbnail: boolean = false;
  isUploadingFont: boolean = false;
  isDeletingGraphics: boolean = false;
  isUpdatingGraphics: boolean = false;
  graphics = [];
  graphicsChosenId: number;
  graphicsDeleteChosenId: number;
  updateRenditionValidityPeriodGraphicsChosenId: number;

  chosenRenditionValidityPeriodMs: number = 0;
  isFileChosen: boolean = false;
  graphicsUploadSampleVideoId: number;
  isUploadingSampleVideo: boolean;

  private static RenditionValidityPeriodDefault = 24 * 60 * 60 * 60 * 1000 - 1;

  constructor(
    private uploadService: UploadService,
    private graphicsRepository: GraphicsRepository,
    private logger: Logger,
    private ui: UI,
    private userService: UserService,
  ) {}

  ngOnInit() {
    this.uploadService.isUploadingGraphics()
      ? (this.isUploadingGraphics = true)
      : (this.isUploadingGraphics = false);
    this.uploadService.isUploadingThumbnail()
      ? (this.isUploadingThumbnail = true)
      : (this.isUploadingThumbnail = false);
    this.uploadService.isUploadingSampleVideo()
      ? (this.isUploadingSampleVideo = true)
      : (this.isUploadingSampleVideo = false);

    this.uploadService.graphicsComplete.subscribe((res) => {
      this.graphics.push({ name: this.graphicsName, id: res });
      this.isUploadingGraphics = false;
    });
    this.uploadService.graphicsError.subscribe((err) => {
      this.isUploadingGraphics = false;
    });
    this.uploadService.thumbnailComplete.subscribe((res) => {
      this.isUploadingThumbnail = false;
    });
    this.uploadService.thumbnailError.subscribe((err) => {
      this.isUploadingThumbnail = false;
    });
    this.uploadService.sampleVideoComplete.subscribe((res) => {
      this.isUploadingSampleVideo = false;
    });
    this.uploadService.sampleVideoError.subscribe((err) => {
      this.isUploadingSampleVideo = false;
    });
    this.uploadService.fontComplete.subscribe((res) => {
      this.userService.refreshCurrentUser().then();
      this.isUploadingFont = false;
    });
    this.uploadService.fontError.subscribe((err) => {
      this.isUploadingFont = false;
    });

    this.graphicsRepository
      .getTemplatesNamesAndIds()
      .then((response) => {
        this.graphics = response;
      })
      .catch((err) => {
        this.logger.error(
          "couldn't get graphics templates names and ids " + err,
        );
      });

    this.chosenRenditionValidityPeriodMs =
      UploadGraphicsComponent.RenditionValidityPeriodDefault;
  }

  onGraphicsInputFileChange(e) {
    if (e.target.files.length === 0) {
      this.graphicsFileChosenName = "";
      this.file = null;
    } else {
      this.file = e.target.files[0];
      this.graphicsFileChosenName = this.file.name;
    }
  }

  onThumbnailInputFileChange(e) {
    if (e.target.files.length === 0) {
      this.thumbnailFileChosenName = "";
      this.file = null;
    } else {
      this.file = e.target.files[0];
      this.thumbnailFileChosenName = this.file.name;
    }
  }

  onSampleVideoInputFileChange(e) {
    if (e.target.files.length === 0) {
      this.sampleVideoFileChosenName = "";
      this.file = null;
    } else {
      this.file = e.target.files[0];
      this.sampleVideoFileChosenName = this.file.name;
    }
  }

  onFontInputFileChange(e) {
    if (e.target.files.length === 0) {
      this.fontFileChosenName = "";
      this.file = null;
    } else {
      this.file = e.target.files[0];
      this.fontFileChosenName = this.file.name;
      this.fontName = this.fontFileChosenName.split(".")[0];
      this.isFileChosen = true;
    }
  }

  uploadGraphics() {
    if (this.file && this.graphicsName != "") {
      this.uploadService.uploadGraphicsFile(
        this.file,
        this.graphicsName,
        this.graphicsDescription,
      );
    }
  }

  uploadThumbnail() {
    if (this.file && this.graphicsChosenId) {
      this.uploadService.uploadGraphicsThumbnailFile(
        this.file,
        this.graphicsChosenId,
      );
    }
  }

  uploadSampleVideo() {
    if (this.file && this.graphicsUploadSampleVideoId) {
      this.uploadService.uploadGraphicsSampleVideo(
        this.file,
        this.graphicsUploadSampleVideoId,
      );
    }
  }

  uploadFont() {
    if (this.file && this.fontName) {
      this.uploadService.uploadFontFile(this.file, this.fontName);
    }
  }

  updateRenditionValidityPeriod() {
    if (this.updateRenditionValidityPeriodGraphicsChosenId) {
      this.isUpdatingGraphics = true;
      this.graphicsRepository
        .updateRenditionValidityPeriod(
          this.updateRenditionValidityPeriodGraphicsChosenId,
          this.chosenRenditionValidityPeriodMs,
        )
        .then((res) => {
          this.isUpdatingGraphics = false;

          this.updateRenditionValidityPeriodGraphicsChosenId = null;
          this.chosenRenditionValidityPeriodMs =
            UploadGraphicsComponent.RenditionValidityPeriodDefault;

          this.ui.notify(this.ui.EVENTS.ShowAlert, {
            title: "Update  Rendition Validity Period",
            message: "Success",
          });
        })
        .catch((err) => {
          this.ui.notify(this.ui.EVENTS.ShowAlert, {
            title: "Update  Rendition Validity Period",
            message: err.error.message,
          });
          this.isUpdatingGraphics = false;
        });
    }
  }

  deleteGraphics() {
    if (this.graphicsDeleteChosenId) {
      this.isDeletingGraphics = true;
      this.graphicsRepository
        .deleteGraphics(this.graphicsDeleteChosenId)
        .then((res) => {
          this.isDeletingGraphics = false;
          this.graphics = this.graphics.filter((x) => {
            x.id !== this.graphicsDeleteChosenId;
          });
          this.graphicsDeleteChosenId = null;
        })
        .catch((err) => {
          this.ui.notify(this.ui.EVENTS.ShowAlert, {
            title: "Delete Graphic",
            message: err.error.message,
          });
          this.isDeletingGraphics = false;
        });
    }
  }
}
